import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ScrollReveal from 'scrollreveal';
import CertsCarousel from '../../components/certsCarousel/CertsCarousel';
import TestimonialsGrid from '../socialProofScreen/TestimonialsGrid';
import styles from './ThankYouScreen.module.css';

function ThankYouScreen() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    ScrollReveal().reveal(`.${styles.testimonialsTitle}`, {
      origin: 'bottom', distance: '24px', duration: 800,
      easing: 'cubic-bezier(0.22, 1, 0.36, 1)', reset: false,
    });
    ScrollReveal().reveal(`.${styles.backBtn}`, {
      origin: 'bottom', distance: '16px', duration: 600,
      easing: 'cubic-bezier(0.22, 1, 0.36, 1)', reset: false,
    });
  }, []);

  return (
    <div className={styles.page} dir="rtl">

      {/* ══════ HERO SECTION ══════ */}
      <div className={styles.hero}>
        <div className={styles.glowTop} />
        <div className={styles.glowBottom} />

        <div className={styles.heroContent}>
          {/* Heart icon */}
          <div className={`${styles.iconWrap} ${styles.heartEnter}`}>
            <svg viewBox="0 0 24 24" fill="none" className={styles.heartIcon}>
              <path
                d="M12 21C12 21 3 14.5 3 8.5C3 5.42 5.42 3 8.5 3C10.24 3 11.91 3.81 13 5.08C14.09 3.81 15.76 3 17.5 3C20.58 3 23 5.42 23 8.5C23 14.5 14 21 12 21Z"
                fill="rgba(239,174,174,0.25)"
                stroke="#efaeae"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          {/* Title */}
          <h1 className={`${styles.title} ${styles.titleEnter}`}>
            איזה כיף שהשארת פרטים
          </h1>

          {/* Divider */}
          <div className={`${styles.divider} ${styles.dividerEnter}`} />

          {/* Subtitle */}
          <p className={`${styles.subtitle} ${styles.subtitleEnter}`}>
            כולי תקווה שתצטרפי לנבחרת שלי
          </p>
        </div>
      </div>

      {/* ══════ CERTS CAROUSEL ══════ */}
      <div className={styles.carouselSection}>
        <CertsCarousel />
      </div>

      {/* ══════ TESTIMONIALS SECTION ══════ */}
      <div className={styles.testimonialsSection}>
        <h2 className={styles.testimonialsTitle}>
          אלו התגובות שלהן <em className={styles.em}>בסוף הקורס:</em>
        </h2>
      </div>

      <TestimonialsGrid dark />

      {/* ══════ BACK BUTTON ══════ */}
      <div className={styles.backSection}>
        <button
          className={styles.backBtn}
          onClick={() => navigate('/')}
        >
          חזרה לדף הראשי
        </button>
      </div>
    </div>
  );
}

export default ThankYouScreen;
